<template>
  <div>
    <div class="mx-5 py-5 d-flex justify-space-between">
      <h5>Membership</h5>
      <v-icon @click="close()">mdi-close</v-icon>
    </div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
        <v-container class="mt-4">
          <v-select
          v-model="form.MembershipId"
            class="pt-0"
            :items="membershipitems"
            label="Membership"
            single-line
            item-text="text"
            item-value="id"
            :error-messages="
                  $v.form.MembershipId.$error ? 'Membership is required' : null
                "
          ></v-select>

          <v-menu
            ref="datarangemenu"
            v-model="datarangemenu"
            :close-on-content-click="false"
            :return-value.sync="form.ExtendDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
              class="mt-5"
                v-model="form.ExtendDate"
                label="To Date"
                append-icon="mdi-calendar-range-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                single-line
                :error-messages="
                  $v.form.ExtendDate.$error ? 'ExtendDate is required' : null
                "
                ></v-text-field>
            </template>
            <v-date-picker v-model="form.ExtendDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="datarangemenu = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.datarangemenu.save(form.ExtendDate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-container>
      </v-form>
    </v-card>
    <div class="d-flex justify-end mx-5 py- pt-8 pb-8">
      <v-btn
        class="px-10 py-6 text_transform"
        color="#A1A3A8"
        text
        @click="close()"
      >
        Cancel
      </v-btn>
      <v-btn
        depressed
        color="primary"
        class="px-14 py-6 text_transform"
        :disabled="btnloader"
        @click="send()"
      >
        <span v-if="btnloader != true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  required,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  mixins: [validationMixin],
  name: "editteamcomponent",
  components: {},
  computed: {
    ...mapGetters(["GetPreviewUser"])
  },
  mounted(){
    this.form.UserId = this.GetPreviewUser.Id
  },
  data() {
    return {
      btnloader: false,
      Membereditdialog: false,
      datarangemenu: false,
      dates: [],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      form: {
        UserId: null,
        ExtendDate: "",
        MembershipId: null,
      },
      // membershipitems: ["Public access", "Starter", "Access", "Standard", "Practitioner", "Instructor", "Trainee Instructor", "Senior Instructor", "Deceased"],
      membershipitems: [
        { text: "Starter - $0", id: 1 },
        { text: "Access - $40", id: 2 },
        { text: "Standard - $150", id: 3 },
        { text: "Practitioner - $300", id: 4 },
        { text: "Instructor - $300", id: 5 },
        { text: "Deceased - $0", id: 7 },
        { text: "Inactive  - $0", id: 8 },
        { text: "Trainee Instructor - $300", id: 9 },
        { text: "Senior Instructor - $300", id: 10 },
      ],
      valid: false,
      Amount: "",
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  validations:{
    form:{
      ExtendDate:{
        required
      },
      MembershipId:{
        required
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    send(){
      this.$v.form.$touch()
      if(this.$v.form.$invalid){
        return
      }
      this.btnloader = true
      this.$store.dispatch("EditMembershipWithoutPayment",this.form).then(()=>{
        this.btnloader = false
        this.close()
        const obj = {
          id: this.GetPreviewUser.Id,
        };
         this.$store.dispatch("GetMembershipByUserId", obj);
      })
    }
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
</style>
